<template>
  <div class="container">
    <div>
      <calculator-card :title="$t('company_tax_calculate')" :theme="`gbp`">
        <CompanyTax />
      </calculator-card>

      <calculator-card :title="$t('personal_tax_calculate')" :theme="`gbp`">
        <PersonalTax />
      </calculator-card>
    </div>
  </div>
</template>

<script>
import CompanyTax from "./components/calculators/CompanyTax.vue";
import PersonalTax from "./components/calculators/PersonalTax/PersonalTax.vue";

export default {
  components: {
    CompanyTax,
    PersonalTax,
  },
};
</script>
